var _style, _defs, _defs2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000145737727465253865970000010072186706696378754_)}.st1{clip-path:url(#SVGID_00000090998331683914930370000001310191396911262632_);fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M2 71.5c0-2.6 4.4-4.8 4.7-7.3.3-2.5-3.5-5.7-2.9-8.2s5.3-3.7 6.2-6.1c.8-2.4-2.1-6.4-1-8.6 1.1-2.3 6-2.4 7.4-4.6 1.3-2.1-.7-6.7.9-8.6 1.6-2 6.4-1 8.2-2.8 1.8-1.8.8-6.6 2.8-8.2 2-1.6 6.5.4 8.6-.9 2.1-1.3 2.3-6.3 4.6-7.4s6.2 1.9 8.6 1c2.4-.8 3.6-5.6 6.1-6.2 2.4-.6 5.6 3.2 8.2 2.9C66.7 6.4 69 2 71.5 2c2.6 0 4.8 4.4 7.3 4.7 2.5.3 5.7-3.5 8.2-2.9s3.7 5.3 6.1 6.2c2.4.8 6.3-2.1 8.6-1s2.4 6 4.6 7.4c2.1 1.3 6.7-.7 8.6.9 2 1.6 1 6.4 2.8 8.2 1.8 1.8 6.6.8 8.2 2.8s-.4 6.5.9 8.6c1.3 2.1 6.3 2.3 7.4 4.6s-1.9 6.2-1 8.6c.8 2.4 5.6 3.6 6.2 6.1.6 2.4-3.2 5.6-2.9 8.2.3 2.5 4.7 4.8 4.7 7.3s-4.4 4.8-4.7 7.3 3.5 5.7 2.9 8.2-5.3 3.7-6.2 6.1c-.8 2.4 2.1 6.3 1 8.6s-6 2.4-7.4 4.6c-1.3 2.1.7 6.7-.9 8.6-1.6 2-6.4 1-8.2 2.8-1.8 1.8-.8 6.6-2.8 8.2s-6.5-.4-8.6.9c-2.1 1.3-2.3 6.3-4.6 7.4-2.3 1.1-6.2-1.9-8.6-1-2.4.8-3.6 5.6-6.1 6.2-2.4.6-5.6-3.2-8.2-2.9-2.5.3-4.8 4.7-7.3 4.7-2.6 0-4.8-4.4-7.3-4.7s-5.7 3.5-8.2 2.9-3.7-5.3-6.1-6.2c-2.4-.8-6.3 2.1-8.6 1s-2.4-6-4.6-7.4c-2.1-1.3-6.7.7-8.6-.9-2-1.6-1-6.4-2.8-8.2-1.8-1.8-6.6-.8-8.2-2.8-1.6-2 .4-6.5-.9-8.6s-6.3-2.3-7.4-4.6c-1.1-2.3 1.9-6.2 1-8.6-.8-2.4-5.6-3.6-6.2-6.1-.6-2.4 3.2-5.6 2.9-8.2-.1-2.7-4.5-4.9-4.5-7.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018213394452007170440000004313943904140108718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000018213394452007170440000004313943904140108718_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000147214561301164001700000002130590847311766203_",
    d: "M-206-364h390v997h-390z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031910036506329476190000000666448796953564599_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147214561301164001700000002130590847311766203_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000031910036506329476190000000666448796953564599_)",
      fill: "#fff"
    },
    d: "M1 1h141v141H1V1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 71.5c0-2.6 4.4-4.8 4.7-7.3.3-2.5-3.5-5.7-2.9-8.2s5.3-3.7 6.2-6.1c.8-2.4-2.1-6.4-1-8.6 1.1-2.3 6-2.4 7.4-4.6 1.3-2.1-.7-6.7.9-8.6 1.6-2 6.4-1 8.2-2.8 1.8-1.8.8-6.6 2.8-8.2 2-1.6 6.5.4 8.6-.9 2.1-1.3 2.3-6.3 4.6-7.4s6.2 1.9 8.6 1c2.4-.8 3.6-5.6 6.1-6.2 2.4-.6 5.6 3.2 8.2 2.9C66.7 6.4 69 2 71.5 2c2.6 0 4.8 4.4 7.3 4.7 2.5.3 5.7-3.5 8.2-2.9s3.7 5.3 6.1 6.2c2.4.8 6.3-2.1 8.6-1s2.4 6 4.6 7.4c2.1 1.3 6.7-.7 8.6.9 2 1.6 1 6.4 2.8 8.2s6.6.8 8.2 2.8-.4 6.5.9 8.6c1.3 2.1 6.3 2.3 7.4 4.6s-1.9 6.2-1 8.6c.8 2.4 5.6 3.6 6.2 6.1.6 2.4-3.2 5.6-2.9 8.2.3 2.5 4.7 4.8 4.7 7.3s-4.4 4.8-4.7 7.3 3.5 5.7 2.9 8.2-5.3 3.7-6.2 6.1c-.8 2.4 2.1 6.3 1 8.6s-6 2.4-7.4 4.6c-1.3 2.1.7 6.7-.9 8.6-1.6 2-6.4 1-8.2 2.8-1.8 1.8-.8 6.6-2.8 8.2s-6.5-.4-8.6.9c-2.1 1.3-2.3 6.3-4.6 7.4-2.3 1.1-6.2-1.9-8.6-1-2.4.8-3.6 5.6-6.1 6.2-2.4.6-5.6-3.2-8.2-2.9-2.5.3-4.8 4.7-7.3 4.7-2.6 0-4.8-4.4-7.3-4.7s-5.7 3.5-8.2 2.9-3.7-5.3-6.1-6.2c-2.4-.8-6.3 2.1-8.6 1s-2.4-6-4.6-7.4c-2.1-1.3-6.7.7-8.6-.9-2-1.6-1-6.4-2.8-8.2-1.8-1.8-6.6-.8-8.2-2.8-1.6-2 .4-6.5-.9-8.6s-6.3-2.3-7.4-4.6c-1.1-2.3 1.9-6.2 1-8.6-.8-2.4-5.6-3.6-6.2-6.1-.6-2.4 3.2-5.6 2.9-8.2-.1-2.7-4.5-4.9-4.5-7.5",
    style: {
      fill: "none",
      stroke: "#31348b",
      strokeWidth: 4,
      strokeMiterlimit: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.91ddb0792b30ac13b3858a94a16fefb8.svg";
export { ForwardRef as ReactComponent };